import React from 'react';

import { InjectedIntl } from 'react-intl';

import Button from '@atlaskit/button/standard-button';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { Commit } from 'src/components/types';
import commitStatMessages from 'src/sections/repository/sections/commit-list/components/commit-list.i18n';
import * as iconStyles from 'src/sections/repository/sections/commit-list/components/commit-list.style';
import { IconWithCountWrapper, IconWithCountIconWrapper } from 'src/styles';

export const renderApproval = (commit: Commit, intl: InjectedIntl) => {
  const participants = commit.participants || [];
  const approvalCount = participants.filter(p => p.approved).length;

  if (!approvalCount) {
    return null;
  }

  const participantsUrl = `${commit.links.html.href}#participants`;

  return (
    <iconStyles.CommitStat>
      <Button appearance="subtle-link" href={participantsUrl} spacing="none">
        <IconWithCountWrapper>
          <IconWithCountIconWrapper>
            <CheckCircleIcon
              label={intl.formatMessage(commitStatMessages.approvals)}
              primaryColor={token('color.icon.success', colors.G400)}
              size="small"
              testId="approval-indicator"
            />
          </IconWithCountIconWrapper>
          {approvalCount}
        </IconWithCountWrapper>
      </Button>
    </iconStyles.CommitStat>
  );
};
